// @ts-nocheck
import styled from "styled-components";

export const Wrapper = styled("div")`
  height: 320px;
  padding: 20px;
`;
